import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import JourneyImage from '../../../../public/assets/images/home-images/homepage-journey.webp';
import JourneyImageAR from '../../../../public/assets/images/home-images/homepage-journey-ar.webp';
import JourneyQR from '../../../../public/assets/images/home-images/journey-qr.png';
import { useSelector } from 'react-redux';
import DownloadApp from '../../../../new-components/ui/DownloadApp';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from 'next/image';

const WebAppJourney = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation('home');
  const { locale } = useRouter();

  return isMobile ? (
    <MobileContainer locale={locale} href="https://nawyapp.go.link/hqqVY">
      <div className="img-container">
        <ImageWrapper
          className="journey-img"
          src={locale == 'en' ? JourneyImage : JourneyImageAR}
          alt="image"
          width={locale == 'en' ? 320 : 280}
          height={300}
          loading={'lazy'}
        />
      </div>
      <div className="journey-text">
        <span className="header">
          {t('journey_header')}

          <Image
            src="/assets/icons/common/underline.svg"
            alt="Banner Underline"
            width={220}
            height={28}
          />
        </span>
        <span className="sub-header">{t('journey_subheader')}</span>
      </div>
      <div className="download-container">
        <DownloadApp
          iconWidth="auto"
          iconHeight="38px"
          iconColor={'#0C314E'}
          eventLocation="homepage"
        />
      </div>
    </MobileContainer>
  ) : (
    <Container locale={locale}>
      <div className="journey-text">
        <span className="header">
          {t('journey_header')}
          <Image
            src="/assets/icons/common/underline.svg"
            alt="Banner Underline"
            width={270}
            height={18}
          />
        </span>
        <span className="sub-header">{t('journey_subheader')}</span>
      </div>
      <ImageWrapper
        className="journey-img"
        src={locale == 'en' ? JourneyImage : JourneyImageAR}
        alt="image"
        width={locale == 'en' ? 390 : 340}
        height={390}
      />
      <div className="qr-container">
        <ImageWrapper
          src={JourneyQR}
          alt="Download App QR Code"
          width={104}
          height={102}
        />
        <span>{t('scan_qr')}</span>
      </div>
    </Container>
  );
};

const Container = styled.div<any>`
  margin-top: 80px;
  width: 100%;
  padding: 32px;
  height: 288px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #dbe2e9;
  gap: 8px;

  ${props =>
    props?.locale === 'en'
      ? 'background-image:  url("assets/images/home-images/journey-bg.webp")'
      : 'background-image:  url("assets/images/home-images/journey-bg-ar.webp")'};

  .journey-text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 52%;
    .header {
      color: #212427;
      font-family: materialBold;
      font-size: 36px;
      text-transform: capitalize;
      position: relative;

      img {
        position: absolute;
        pointer-events: none;
        top: 40px;
        ${props => (props?.locale === 'en' ? 'left: 21%' : 'left: 38%')};
      }
    }

    .sub-header {
      color: #525252;
      font-family: materialRegular;
      font-size: 18px;
      text-transform: capitalize;
    }
  }

  .journey-img {
    margin-bottom: 110px;
    margin-left: 60px;
  }

  .qr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    width: 121px;
    height: 171px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.35);
    box-shadow: 0px 0px 8px 0px rgba(138, 146, 154, 0.2);
    padding: 8px;

    span {
      color: #000;
      text-align: center;
      font-family: materialRegular;
      font-size: 14px;
    }
  }
`;

const MobileContainer = styled.a<any>`
  display: flex;
  width: 100%;
  height: auto;
  padding: 0px 16px 32px 16px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  border-radius: 16px;
  border: 1px solid transparent;
  ${props =>
    props?.locale === 'en'
      ? 'background-image:  url("assets/images/home-images/journey-mobile-bg.webp")'
      : 'background-image:  url("assets/images/home-images/journey-mobile-bg-ar.webp")'};

  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 32px;

  .img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .journey-img {
      /* width: 320px;
      height: 300px; */
      margin-top: -40px;
      ${props =>
        props?.locale === 'en' ? 'margin-left: 40px' : 'margin-right: 20px'};
    }
  }
  .journey-text {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .header {
      color: #212427;
      font-family: materialBold;
      font-size: 24px;
      width: 100%;
      text-transform: capitalize;
      position: relative;
      line-height: 35px;

      img {
        position: absolute;
        pointer-events: none;
        top: 24px;
        left: 26%;
      }
    }

    .sub-header {
      font-size: 14px;
      width: 100%;
      text-transform: capitalize;
    }
  }

  .download-container {
    width: 100%;
  }
  .download-btns {
    justify-content: flex-start;
    gap: 25px;
  }
`;

export default WebAppJourney;
